const CALL_STATUS = {
  IDLE: "IDLE",
  START: "START",
  ACTIVE: "ACTIVE",
  ERROR: "ERROR",
  END: "END"
};

export default CALL_STATUS;
